import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { accountingApi } from './api'
import { monthLabel, statusTone } from './format'

const tone = { ok: 'bg-emerald-900/40 text-emerald-200', warn: 'bg-amber-900/40 text-amber-100', live: 'bg-sky-900/40 text-sky-100', muted: 'bg-ink-600 text-paper/60' }

export function ClosesPage() {
  const { data, isLoading, error } = useQuery({ queryKey: ['accounting', 'closes'], queryFn: accountingApi.closes })
  if (isLoading) return <p>Loading…</p>
  if (error || !data) return <p role="alert">Could not load the closes.</p>
  return (
    <div className="flex flex-col gap-6">
      <h1 className="font-serif text-2xl">Monthly closes</h1>
      <p className="max-w-2xl text-paper/70">A draft is built for every title on the 1st and rebuilt every night until you approve it. Approving locks the month; anything that arrives later is booked into the next open month. The current month is shown in progress, with live figures, until it ends.</p>
      {data.titles.length === 0 && <p className="text-paper/70">AAMCirc does not hold any title's books yet.</p>}
      {data.titles.map((t) => (
        <section key={t.slug} className="rounded-xl border border-ink-500 bg-ink-800 p-4">
          <h2 className="font-serif text-lg">{t.name}</h2>
          <p className="text-[12px] text-paper/60">Books held in AAMCirc from {monthLabel(t.takeover)}; the opening balance is SimpleCirc's prepaid membership months at the end of the month before.</p>
          <ul className="mt-3 flex flex-wrap gap-2">
            {t.months.map((m) => (
              <li key={m.period}>
                <Link to={`/accounting/${t.slug}/${m.period}`} className={`inline-flex flex-col rounded-lg px-3 py-2 ${tone[statusTone(m.status)]}`}>
                  <span className="font-semibold">{monthLabel(m.period)}</span>
                  <span className="text-[12px]">{m.status}{m.balanced === false ? ' · does not balance' : ''}</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}
